import { LifebuoyIcon } from "@heroicons/react/24/outline";
import { SidebarMode } from "components/layout/sidebar";
import React, { useCallback } from "react";
import { useFeature } from "store/selectors/hooks";
import { NgSidebarItem } from "./ng-sidebar-item";
import { WhiteLabelRestricted } from "./white-label-restricted";

interface HasBeacon {
    Beacon?: (action: string, configOrEvent?: unknown) => void;
}

export const HelpScoutSidebarItem: React.FC<{ mode: SidebarMode }> = ({ mode }) => {
    const supportIconRelocate = useFeature("supportIconRelocate");
    const handleClick = useCallback((e: React.MouseEvent) => {
        e.preventDefault();
        const Beacon = (window as HasBeacon).Beacon;
        if (Beacon) {
            Beacon("config", { display: { style: "manual", position: "left" } });
            Beacon("open");
        }
    }, []);

    if (!supportIconRelocate) {
        return null;
    }

    return (
        <WhiteLabelRestricted>
            <NgSidebarItem
                href="#"
                current={false}
                icon={LifebuoyIcon}
                label="Support"
                mode={mode}
                onClick={handleClick}
            />
        </WhiteLabelRestricted>
    );
};
